import StripePlan from './StripePlan'

class StripeCoupon {
    static idForPlanId = (stripeCouponId, planId) => {
        if(StripePlan.isAnnualPlanId(planId)) return ''
        return stripeCouponId
    }
}

export default StripeCoupon